// extracted by mini-css-extract-plugin
export default {"donationBlock":"DonationBlock_donationBlock__GNNML","name":"DonationBlock_name__W+9PX","value":"DonationBlock_value__Sl4r4","donationHeader":"DonationBlock_donationHeader__vXc31"};